import { List, ListItem, isListItem } from '@sm/max-common';

export interface HistoryStack {
  params: any;
  url: string;
}

export function History(isSpa: boolean) {
  let stacks: List<HistoryStack> = new List();
  let current: ListItem<HistoryStack> = stacks.first;

  function go(num: number, params: any) {
    if (isSpa) {
      const op = num > 0;
      const step = Math.abs(num);
      for (let i = 0; i < step; i++) {
        const nextStep = op ? current.next : current.last;
        if (isListItem(nextStep)) {
          // 更新路由参数
          nextStep.value.params = params;
          // 设置当前路由信息
          current = nextStep;
        }
      }
    } else {
      history.go(num);
    }
  }

  function pushState(params: any, noUse: string, url: string) {
    if (isSpa) {
      const value: HistoryStack = {
        params,
        url: url.startsWith('/') ? url.substring(1) : url,
      };
      if (current) {
        const item: ListItem<HistoryStack> = {
          value,
          last: current,
          next: current.next,
        };
        item.last.next = item;
        item.next.last = item;
        current = item;
      } else {
        stacks.push(value);
        current = stacks.last;
      }
    } else {
      history.pushState(params, noUse, url);
    }
  }

  function replaceState(params: any, noUse: string, url?: string) {
    if (isSpa) {
      if (stacks.last?.value) {
        stacks.last.value.params = params;
        if (url) {
          stacks.last.value.url = url.startsWith('/') ? url.substring(1) : url;
        }
      } else {
        const value: HistoryStack = {
          params,
          url: url.startsWith('/') ? url.substring(1) : url,
        };
        stacks.push(value);
        current = stacks.last;
      }
    } else {
      history.replaceState(params, noUse, url);
    }
  }

  function clear() {
    if (isSpa) {
      stacks = new List();
    }
  }

  return {
    go,
    pushState,
    replaceState,
    clear,
    get state() {
      return isSpa ? current?.value.params : history.state;
    },
    get url() {
      return isSpa ? current?.value.url : location.pathname.substring(1);
    },
    popstate: null,
  };
}
